import React, { useEffect } from 'react';
import { compose } from 'redux';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import SendDownLinkCommandV2 from './components/SendDownLinkCommnad';
import './style.css';
import AppHeader from './components/AppHeader';
import { Footer } from 'antd/es/layout/layout';
import { useRole } from '@contexts/Auth/UseRole';
import Page403 from '@page/Common/403/403';

const SendDownLinkV2 = () => {
  const { isWebSuperAdmin, isWebAdmin, isWebManager, isWebWorker } = useRole();
  const isHavePermission = isWebSuperAdmin || isWebAdmin || isWebManager || isWebWorker;

  useEffect(() => {
    const metaViewport = document.querySelector('meta[name="viewport"]');
    if (metaViewport) {
      metaViewport.setAttribute('content', 'width=device-width, initial-scale=1');
    }

    // Khôi phục giá trị mặc định khi rời khỏi trang
    return () => {
      if (metaViewport) {
        metaViewport.setAttribute('content', 'width=device-width, initial-scale=0.2');
      }
    };
  }, []);
  return (
    <div className="container">
      <AppHeader />
      {isHavePermission ? <SendDownLinkCommandV2 /> : <Page403 />}

      <Footer className="footer">
        Copyright © {`${new Date().getFullYear()}`} Bản quyền thuộc về Công ty Cổ phần GBS.
      </Footer>
    </div>
  );
};
export default compose(withPaginate)(SendDownLinkV2);
